import React from 'react';
import request from 'arcdynamic-request';
import {PROPERTIES} from '../../consts/tables';
import { GET_PROPERTIES } from '../Graphql/Queries/propertiesQuery';
import { PROPERTIES_MUTATION } from '../Graphql/Mutations/propertiesMutation';
import { fetchData, mutateData } from '../Service/graphQlService';

function geocode(property, callback) {
	const xhr = new XMLHttpRequest();

	xhr.onload = (e)=> {
		try {
			const res = JSON.parse(e.target.response);
			callback(res.results[0].geometry.location);
		} catch (e) {
			callback(null);
		}
	};
	xhr.onerror = ()=> {callback(null)};
	xhr.open('GET', 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDjYXM4MFH059vLuf5mUgItastWFVrKzv4&address='+encodeURIComponent(`${property.address}, ${property.city}, ${property.state}`));
	xhr.send();
}

function save(property,props) {
	// return request(arc.path.api, {
	// 	service: 'arcimedes',
	// 	action: 'open.datasource.table.Data.updateByTableCode',
	// 	params: [PROPERTIES, {
	// 		value: [
	// 			property,
	// 		],
	// 	}],
	// });
	// let token = localStorage.getItem('authToken');
	// return props.client.mutate({
	// 	mutation: PROPERTIES_MUTATION,
	// 	variables: {
	// 		input: [property],
	// 	},
	// 	fetchPolicy: "no-cache",
	// 	context: {
	// 	  headers: {
	// 		authorization: `Bearer ${token}`,
	// 	  },
	// 	}
	// })
	return mutateData(PROPERTIES_MUTATION, {input: [property]})
}

function fetch(props) {
    	
	//let token = localStorage.getItem('authToken');
	// return request(arc.path.api, {
	// 	service: 'arcimedes',
	// 	action: 'open.datasource.table.Data.getData',
	// 	params: ['code', PROPERTIES, {
	// 		column: [
	// 			'ARCIMEDES_ROW_ID',
	// 			'CITY',
	// 			'STATE',
	// 			'ADDRESS',
	// 			'ZIP',
	// 			'LATITUDE',
	// 			'LONGITUDE',
	// 		],
	// 		limit: {
	// 			count: 1,
	// 			offset: 0,
	// 		},
	// 		filterType: 'and',
	// 		filter: [
	// 			{
	// 				'text': '',
	// 				'code': 'LATITUDE',
	// 				'type': 'null',
	// 			},
	// 			{
	// 				'text': '',
	// 				'code': 'ADDRESS',
	// 				'type': 'notNull',
	// 			},
	// 			{
	// 				'text': '',
	// 				'code': 'CITY',
	// 				'type': 'notNull',
	// 			},
	// 			{
	// 				'text': '',
	// 				'code': 'STATE',
	// 				'type': 'notNull',
	// 			},
	// 		],
	// 	}],
	// });
	if(props.client){
	// return props.client.query({
	// 	query: GET_PROPERTIES,
	// 	variables: { filters: [
	// 		{
	// 			"STATE": "",
	// 			"ADDRESS": "",
	// 			"CITY": "",
	// 			"LONGITUDE": ""
	// 		  }
	// 	] },
	// 	fetchPolicy: "no-cache",
	// 	context: {
	// 	  headers: {
	// 		authorization: `Bearer ${token}`,
	// 	  },
	// 	},
	//   })
	// }
	return fetchData(GET_PROPERTIES,{ filters: [
		{
			"STATE": "",
			"ADDRESS": "",
			"CITY": "",
			"LONGITUDE": ""
		  }
	] })
}
}

export default class GeoCoder extends React.Component {
    constructor(props) {
	super(props);
        this.state = {
            isComplete: false,
            error: null,
        };

        this._crawl = this._crawl.bind(this)
    }

	_crawl() {
		fetch(this.props).then(res => {
			if (res && res.data && res.data.getProperties && Array.isArray(res.data.getProperties.properties)) {
				if (res.data.getProperties.properties[0]) {
					geocode(res.data.getProperties.properties[0], (geo)=> {
						if (geo && geo.lat && geo.lng) {
							res.data.getProperties.properties[0].latitude = geo.lat;
							res.data.getProperties.properties[0].longitude = geo.lng;
							save(res.data.getProperties.properties[0],this.props).then(res => {
								if (!res.success) {
									console.error(res.message);
								}

								setTimeout(function(that){
									that._crawl();
								}, 1000);
							})
						} else {
							console.log('Could not geocode', res.data.getProperties.properties[0]);
							
							setTimeout(function(that){
								that._crawl();
							}, 1000);
						}
					})
				} else {
					this.setState({
						isComplete: true,
						error: null,
					});
				}
			} else {
				this.setState({
					error: res.message ? res.message : 'Could not geocode Error occured',
				})
			}
		});
	}

	componentDidMount() {
		this._crawl();
	}

	render() {
		return (
			<div className='GeoCoder'>
				{
					this.state.isComplete ? <div>Finished!</div> : <div>Geocoding addresses, this may take a few minutes</div>
				}
			</div>
		);
	}
}
